module.exports = __webpack_public_path__ + "img/member_bg.931c3a45.png";